module.exports = __webpack_public_path__ + "1848ba266da7fdcfa523da920c0809f0.png";